var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CRow',[_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Revenue","text":"1,123"}},[_c('CChartBarSimple',{staticStyle:{"height":"40px"},attrs:{"background-color":"success"}})],1)],1),_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Orders","text":"112"}},[_c('CChartBar',{staticStyle:{"height":"40px"},attrs:{"datasets":[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#E55353',
        				label: 'Orders',
      				}
    				],"labels":"months","options":{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}}})],1)],1),_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Product","text":"2121"}},[_c('CChartBar',{staticStyle:{"height":"40px"},attrs:{"datasets":[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#2982cc',
        				label: 'Product',
      				}
    				],"labels":"months","options":{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}}})],1)],1),_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Customer","text":"70"}},[_c('CChartBar',{staticStyle:{"height":"40px"},attrs:{"datasets":[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#1b9e3e',
        				label: 'Orders',
      				}
    				],"labels":"months","options":{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}}})],1)],1),_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Cart Item","text":"70"}},[_c('CChartBar',{staticStyle:{"height":"40px"},attrs:{"datasets":[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#f6960b',
        				label: 'Cart',
      				}
    				],"labels":"months","options":{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}}})],1)],1),_c('CCol',{attrs:{"sm":"4","lg":"2"}},[_c('CWidgetSimple',{attrs:{"header":"Post Reach","text":"70"}},[_c('CChartBar',{staticStyle:{"height":"40px"},attrs:{"datasets":[
      				{
        				data: [10, 22, 34, 46, 58, 70, 46, 23, 45, 78, 34, 12],
        				backgroundColor: '#1f1498',
        				label: 'Cart',
      				}
    				],"labels":"months","options":{ 
							maintainAspectRatio: false,
							legend: {
          			display: false
        			},
        			scales: {
          			xAxes: [{
            			display: false
          			}],
          			yAxes: [{
            			display: false
          			}]
							}
						}}})],1)],1)],1),_c('CCard',[_c('CCardBody',[_c('CRow',[_c('CCol',{attrs:{"sm":"5"}},[_c('h4',{staticClass:"card-title mb-0",attrs:{"id":"traffic"}},[_vm._v("Traffic")]),_c('div',{staticClass:"small text-muted"},[_vm._v("November 2017")])]),_c('CCol',{staticClass:"d-none d-md-block",attrs:{"sm":"7"}},[_c('CButton',{staticClass:"float-right",attrs:{"color":"primary"}},[_c('CIcon',{attrs:{"name":"cil-cloud-download"}})],1),_c('CButtonGroup',{staticClass:"float-right mr-3"},_vm._l((['Day', 'Month', 'Year']),function(value,key){return _c('CButton',{key:key,staticClass:"mx-0",attrs:{"color":"outline-secondary","pressed":value === _vm.selected ? true : false},on:{"click":function($event){_vm.selected = value}}},[_vm._v(" "+_vm._s(value)+" ")])}),1)],1)],1),_c('MainChartExample',{staticStyle:{"height":"300px","margin-top":"40px"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }